import { ArrowUpDown } from "lucide-react"
import {Button} from "../../../components/UiComponents/button"
import {Campus} from "../../../api/client"
import { useMemo } from "react";
import { DateTime } from "luxon";

interface UseColumnsProps {
  onRemove: (appointmentId: string) => void;
  onProcess: (appointmentId: string, studentId:string|undefined) => Promise<void>;
}

const useColumns = ({ onRemove, onProcess }: UseColumnsProps) => {
  return useMemo(() => {
    return [
      {
        accessorKey: "fullName",
        header: ({column}) => (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
          >
            Name
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        ),
      },
      {
        accessorKey: "uIdStudent",
        header: () => (
          <Button variant="ghost">USFID</Button> // Question: What does this Button even do if it does not do anything when clicked?
        ),
      },
      {
        accessorKey: "checkInSince",
        header: ({ column }) => (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
            abbr={column.getIsSorted() === "asc" ? "Click to sort in descending order" : "Click to sort in ascending order"}
          >
            Since
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        ),
        cell: ({row}) => {
          const time = row.original.checkInSince;
          return <span>{DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_MED)}</span>
        }
      },
      {
        accessorKey: "advisorFullName",
        header: () => (
          <Button variant="ghost">Advisor To See</Button> // Question: What does this Button even do if it does not do anything when clicked?
        ),
        cell: ({ row }) => {
          const advisorName = row.original.advisorFullName;
          return <span>{advisorName}</span>;
        },
      },
      {
        accessorKey: "actions",
        header: () => <Button variant="ghost">Actions</Button>,
        cell: ({ row }) => {
          const appointmentId = row.original.appointmentId;
          const studentId = row.original.studentId;
          return (
            <div className={"flex flex-row"}>
              <Button
                size="sm"
                variant="destructive"
                className="mr-3"
                onClick={() => onRemove(appointmentId)}
                abbr="Remove this student from waiting line"
              >
                Remove
              </Button>
              <Button
                size="sm"
                variant="default"
                onClick={() => onProcess(appointmentId, studentId ?? "00000000-0000-0000-0000-000000000000" )}
                abbr="Process this student. They will be out of waiting line and you will be redirected to the student's profile."
              >
                Process
              </Button>
            </div>
          );
        },
      },
    ];
  }, [onRemove, onProcess]);
};

export default useColumns;
